import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-hold',
  templateUrl: './hold.component.html',
})
export class HoldComponent implements OnInit {

  holdForm: FormGroup;
  members$: any[] = [];
  books$: any[] = [];
  loading = false;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    this.holdForm = this.fb.group({
      memberName: ['', Validators.required],
      // Array of selected book IDs
      itemBarcodes: [[], Validators.required]
    });

    this.getMembers();
    this.getBooks();
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  getMembers() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/member/all').subscribe(
      (data: any[]) => {
        this.members$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching members:', err.message);
      }
    );
  }

  getBooks() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/book/all').subscribe(
      (data: any[]) => {
        this.books$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching books:', err.message);
      }
    );
  }

  hold() {
    this.submitted = true;

    if (!this.validateHoldForm()) {
      return;
    }

    const formValue = this.holdForm.value;
    const selectedBookIds: number[] = formValue.itemBarcodes.map((id: any) => parseInt(id));
    const selectedBooks = this.books$.filter(book => selectedBookIds.includes(book.id));

    if (selectedBooks.length === 0) {
      this.toastr.error('No valid items selected.');
      return;
    }

    const statusName = 'On Hold';
    const memberId = formValue.memberName;

    const updates = selectedBooks.map(book =>
      this.httpService
        .updateCirculationStatus(String(book.id), String(memberId), statusName)
        .toPromise()
    );

    Promise.all(updates)
      .then(() => {
        this.toastr.success(`${selectedBooks.length} item(s) placed on hold successfully.`);
        this.closeModal();
      })
      .catch(err => {
        console.error('Hold error:', err);
        this.toastr.error('An error occurred while placing items on hold.');
      });
  }

  validateHoldForm(): boolean {
    if (!this.holdForm) {
      this.toastr.error('Form is not initialized.');
      return false;
    }

    const formValue = this.holdForm.value;

    if (!formValue.memberName) {
      this.toastr.error('Please select a member.');
      return false;
    }

    if (!formValue.itemBarcodes || formValue.itemBarcodes.length === 0) {
      this.toastr.error('Please select at least one item barcode.');
      return false;
    }

    return true;
  }
}